import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import { connect } from 'react-redux';
import store from '../store';
import { loginUser } from '../actions/authentication';
import classnames from 'classnames';
import { Button, Input, InputGroup } from 'rsuite';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';

class Login extends Component {

    constructor() {
        super();
        this.state = {
            email: '',
            passwordVisible: false,
            password: '',
            errors: {}
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePasswordVisible = this.handlePasswordVisible.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(n, v ) {
        this.setState({
            [n]: v
        })
    }
    handlePasswordVisible(e) {
      const s = parseInt(e.currentTarget.getAttribute('state'));
      let v = false;
      if (s === 0) {
        v = true;
      }
      this.setState({
        passwordVisible: v
      })
    }


    handleSubmit(e) {
        e.preventDefault();
        const user = {
            email: this.state.email,
            password: this.state.password,
        }
        this.props.loginUser(user);
    }

    // componentDidMount() {
    //     console.log('Bad navigate!!!');
    //     let state = store.getState(); 
        
    //     // if(this.props.auth.isAuthenticated) {
    //     //     // this.props.history.push('/');
    //     //     this.props.navigate('/')
    //     // }
    // }



    // componentWillReceiveProps(nextProps) {
    //     if(nextProps.auth.isAuthenticated) {
    //         // this.props.history.push('/')
    //         this.props.navigate('/')
    //     }
    //     if(nextProps.errors) {
    //         this.setState({
    //             errors: nextProps.errors
    //         });
    //     }
    // }

    componentDidUpdate(prevProps) {
        console.log('login.props', this.props);
        if(prevProps.auth.isAuthenticated !== this.props.auth.isAuthenticated) {
            // this.props.history.push('/')
            if(this.props.auth.isAuthenticated === true) {
                console.log('componentDidUpdate this.props.auth.isAuthenticated', this.props.auth.isAuthenticated);
                this.props.navigate('/')
            }
        }
        if(prevProps.errors !== this.props.errors) {
            this.setState({
                errors:  this.props.errors
            });
        }
    }

    render() {
        const {errors} = this.state;
        return(
        <div className="container" style={{ marginTop: '50px', width: '700px'}}>
            <h2 style={{marginBottom: '40px'}}>Login</h2>
            <form onSubmit={ this.handleSubmit }>
                <div className="form-group">
                    <Input
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.email
                    })}
                    name="email"
                    onChange={value => {
                      this.handleInputChange('email', value);
                    }}
                    value={ this.state.email }
                    />
                    {errors.email && (<div className="invalid-feedback">{errors.email}</div>)}
                </div>
                <div className="form-group">
                  <InputGroup inside>
                    <Input
                     type={this.state.passwordVisible ? 'text' : 'password'}
                     placeholder="Password"
                     autoComplete="current-password"
                     className={classnames('form-control form-control-lg', {
                         'is-invalid': errors.password
                     })}
                     name="password"
                     onChange={value => {
                       this.handleInputChange('password', value);
                     }}
                     value={ this.state.password }
                    />
                    <InputGroup.Button state={this.state.passwordVisible ? 1 : 0} onClick={this.handlePasswordVisible}>
                      {this.state.passwordVisible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                    {errors.password && (<div className="invalid-feedback">{errors.password}</div>)}
                </div>
                <div className="form-group">
                    <Button size="lg" appearance="primary" type="submit" className="btn btn-primary iron-button">
                        Login User
                    </Button>
                </div>
            </form>
        </div>
        )
    }
}

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors
})

export default connect(mapStateToProps, { loginUser })(withRouter(Login))
// export default connect(mapStateToProps,{ registerUser })(withRouter(Register))
